<template>
  <div>
    <!-- 基于Vant的上传组件封装 -->
    <van-uploader
        v-model="fileList"
        :before-read="beforeRead"
        :after-read="afterRead"
        :max-count="maxCount"
        :max-size="maxSize"
        class="upload_image"
        multiple
        :upload-text="uploadText"
    />
    <!-- 上传进度和状态提示 -->
    <van-dialog v-model:show="showProgress" title="上传中..." show-cancel-button>
      <van-progress :percentage="progressPercent" stroke-width="8" />
      <div class="file-count">正在上传 {{ currentUploadIndex + 1 }}/{{ fileList.length }}</div>
    </van-dialog>
  </div>
</template>

<script>
import COS from 'cos-js-sdk-v5';
import axios from "axios";
import {Toast} from "vant"; // 腾讯云COS SDK

export default {
  name: 'uploadImage',
  props: {
    uploadText: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      default: ''
    },
    // 腾讯云配置（建议从父组件传入）
    cosConfig: {
      type: Object,
      required: true,
      default: () => ({
        tmpSecretKey: undefined,
        tmpSecretId: undefined,
        bucket: undefined,
        region: undefined,
        sessionToken: '',
        domain: '',
      })
    },
    // 最大上传数量
    maxCount: {
      type: Number,
      default: 1
    },
    // 单文件大小限制（字节）
    maxSize: {
      type: Number,
      default: 10 * 1024 * 1024 // 10MB
    }
  },
  data(){
    return {
      fileList: [],
      showProgress: false,
      progressPercent: {},
      currentUploadIndex: 0
    }
  },
  watch: {
    imageUrl: {
      handler(newVal) {
        if (newVal) {
          if (this.fileList.length === 0 || this.fileList[0].url !== newVal) {
            this.fileList = [{ url: newVal }];
          }
        } else {
          this.fileList = [];
        }
      },
      immediate: true
    }
  },
  created() {
  },
  methods: {
    afterRead(files) {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      console.log(files.file);
      const file = files.file
      const that = this
      try {
        const timestamp = new Date().getTime()
        const key = that.cosConfig.dir + '/' + timestamp + '_' + file.name
        // 腾讯云上传 getCosSTS
        const cos = new COS({
          SecretId: that.cosConfig.tmpSecretId,
          SecretKey: that.cosConfig.tmpSecretKey,
          SecurityToken: that.cosConfig.sessionToken,
        });
        cos.putObject({
          Bucket: that.cosConfig.bucket,
          Region: that.cosConfig.region,
          Key: key,
          Body: file,
          onProgress: (progressData) => {
            that.imageUploadPercent = Math.round(
                (progressData.loaded / progressData.total) * 100
            );
          }
        }, (err, data) => {
          console.log("腾讯云上传结果");
          console.log(data);
          if (err) {
            console.error(err);
          } else {
            console.log(data);
            this.uploadImageUrl = that.cosConfig.domain + '/' + key
            this.$emit('successUploadImage', this.uploadImageUrl)
            toast.clear(); // 关闭加载提示
            // 上传成功后的操作，例如更新UI或获取文件URL
          }
        });
      } catch (error) {
        file.status = 'failed';
        file.message = error.message;
        this.$emit('errorUploadImage', error.message)
      }
    },
    beforeRead(file) {
      const validTypes = ['image/jpeg', 'image/png', 'application/pdf'];
      if (!validTypes.includes(file.type)) {
        this.$emit('errorUploadImage', '不支持的文件格式')
        return false;
      }
      return true;
    },
    // 清空上传的文件列表
    clearFile() {
      this.fileList = []  // 清空文件列表
      this.imageUrl = ''  // 清空图片URL
      // 如果有原生 file input，也清空
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    }
  }
};
</script>

<style scoped>
.file-count {
  text-align: center;
  margin-top: 15px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/upload_image.vue